import React, { useEffect, useState } from 'react';
import { Input, Select } from '../../../components/ui/Input';
import Btn from '../../../components/ui/Btn';
import { produtosApi } from '../../../api/produtos';
import { composicaoApi } from '../../../api/estoque';

export default function ComposicaoTab({ produtoId, temComposicao }) {
  const [itens, setItens] = useState([]);
  const [produtosDisponiveis, setProdutosDisponiveis] = useState([]);
  const [salvando, setSalvando] = useState(false);

  const habilitado = !!temComposicao;

  useEffect(() => {
    if (!produtoId) return;
    composicaoApi.listar(produtoId).then(rows => setItens(rows.map(r => ({
      produto_filho_id: r.produto_filho_id, descricao: r.produto_filho_descricao,
      quantidade: r.quantidade, unidade: r.unidade, perda_pct: r.perda_pct
    })))).catch(() => {});
    produtosApi.listar({ limite: 200 }).then(setProdutosDisponiveis).catch(() => {});
  }, [produtoId]);

  if (!produtoId) return <p style={{ color: '#697180', fontSize: 14 }}>Salve o produto antes de montar a composição.</p>;
  if (!habilitado) return <p style={{ color: '#697180', fontSize: 14 }}>Marque "Este produto tem composição?" na aba Ficha Técnica (seção Controle de Estoque) pra habilitar.</p>;

  const adicionarLinha = () => setItens(i => [...i, { produto_filho_id: '', quantidade: 1, unidade: '', perda_pct: 0 }]);
  const removerLinha = (idx) => setItens(i => i.filter((_, x) => x !== idx));
  const atualizarLinha = (idx, campo, valor) => setItens(i => i.map((item, x) => x === idx ? { ...item, [campo]: valor } : item));

  const opcoesProdutos = produtosDisponiveis.filter(p => p.id !== produtoId).map(p => ({ value: p.id, label: `${p.codigo} - ${p.nome}` }));

  const salvar = async () => {
    setSalvando(true);
    try {
      await composicaoApi.salvar(produtoId, itens.filter(i => i.produto_filho_id));
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {itens.map((item, idx) => (
          <div key={idx} style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr auto', gap: 10, alignItems: 'end' }}>
            <Select label="Insumo/Componente" options={[{ value: '', label: 'Selecione...' }, ...opcoesProdutos]}
              value={item.produto_filho_id} onChange={e => atualizarLinha(idx, 'produto_filho_id', e.target.value)} />
            <Input label="Quantidade" type="number" step="0.0001" value={item.quantidade} onChange={e => atualizarLinha(idx, 'quantidade', e.target.value)} />
            <Input label="Unidade" value={item.unidade || ''} onChange={e => atualizarLinha(idx, 'unidade', e.target.value)} />
            <Input label="% Perda" type="number" step="0.01" value={item.perda_pct || 0} onChange={e => atualizarLinha(idx, 'perda_pct', e.target.value)} />
            <Btn variante="danger" onClick={() => removerLinha(idx)}>Remover</Btn>
          </div>
        ))}
      </div>
      <div style={{ marginTop: 14, display: 'flex', gap: 10 }}>
        <Btn variante="secondary" onClick={adicionarLinha}>+ Adicionar Item</Btn>
        <Btn onClick={salvar} disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar Composição'}</Btn>
      </div>
    </div>
  );
}
